<template>
  <div>
    <!-- 显示地图 -->
    <point-on-map @getLatLng="getLatLng"
                  :porplat="lat"
                  :proplng="lng"
                  @selectSuggestion="selectSuggestion"
                  style="margin-bottom:20px"
                  ref="pointOnMap"></point-on-map>
    <!-- tap块 -->
    <el-tabs v-model="activeName"
             type="card">
      <!-- 添加 -->
      <el-tab-pane label="添加POI"
                   name="first">
        <div class="add-poi-tab-pane">
          <el-form :label-position="labelPosition"
                   :model="formLabelAlign"
                   label-width="180px">
            <el-form-item label="POI名称:">
              <el-input style="width: 250px"
                        size="mini"
                        v-model="formLabelAlign.poi_name"></el-input>
            </el-form-item>
            <el-form-item size="mini"
                          label="所属目的地:">
              <el-cascader style="width: 250px"
                           size="mini"
                           :show-all-levels="false"
                           v-model="formLabelAlign.dest"
                           :options="option"
                           :props="defaultProp"
                           clearable
                           filterable></el-cascader>
            </el-form-item>
            <el-form-item label="POI坐标:">
              经度：
              <el-input style="width: 250px"
                        size="mini"
                        v-model="formLabelAlign.location.lng"></el-input>
              纬度：
              <el-input style="width: 250px"
                        size="mini"
                        v-model="formLabelAlign.location.lat"></el-input>
            </el-form-item>
          </el-form>
          <!-- 提交 -->
          <el-button size="mini"
                     @click="submitPOI"
                     type="primary">提交并绑定POI</el-button>
          <!-- 取消 -->
          <el-button size="mini"
                     @click="closeSubmitPOI"
                     type="">关闭</el-button>
        </div>
      </el-tab-pane>
      <!-- 选择poi -->
      <el-tab-pane label="选择POI"
                   name="second">
        <div class="little-card-poi">
          <div>
            <span>选择目的地：</span>
            <!-- 选择目的地 -->
            <el-cascader size="mini"
                         v-model="destId"
                         :options="option"
                         @change="selectPoiDest"
                         :props="selectDestProp"
                         clearable></el-cascader>
            <!-- 搜索poi -->
            <span style="margin-left: 20px">搜索POI：</span>
            <el-input placeholder="请输入名称"
                      style="width:180px"
                      v-model="keyWord"
                      size="mini">
              <el-button slot="append"
                         @click="searchPoi"
                         icon="el-icon-search"></el-button>
            </el-input>
            <!-- 绑定按钮 -->
            <el-button @click="bandPoiToTraverPoint"
                       size="mini"
                       style="float: right"
                       type="primary">绑定POI:{{ poi_id }}</el-button>
          </div>

          <!-- poi列表 -->
          <div style="cursor: pointer">
            <el-table ref="multipleTable"
                      :data="poi_list"
                      tooltip-effect="dark"
                      style="width: 100%"
                      highlight-current-row
                      @current-change="handleSelectionChange">
              <el-table-column label=""
                               width="60">
                <template slot-scope="scope">{{ scope.row.poi_id }}</template>
              </el-table-column>
              <el-table-column label=""
                               width="auto">
                <template slot-scope="scope">{{ scope.row.poi_name }}</template>
              </el-table-column>
              <el-table-column prop="name"
                               label=""
                               width="60">
                <template slot-scope="scope">{{ scope.row.dest }}</template>
              </el-table-column>
              <el-table-column prop="address"
                               label=""
                               show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.lat }}</template>
              </el-table-column>
              <el-table-column prop="address"
                               label=""
                               show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.lng }}</template>
              </el-table-column>
            </el-table>
            <!-- ----------------- 分页 ------------------ -->
            <div class="pagination">
              <el-pagination @current-change="handleCurrentChange_system"
                             :small="true"
                             background
                             layout="prev, pager, next,total"
                             :current-page.sync="pagenum_system"
                             :page-size="page_size"
                             :total="page_account"></el-pagination>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PointOnMap from '../../components/map/PointOnMap'
export default {
  name: 'select-or-add-poi-list',
  components: {
    PointOnMap,
  },
  data() {
    return {
      activeName: 'first',
      // 获取指定目的地poi列表
      destId: '',
      keyWord: '',
      option: [], // 目的地可选项
      poi_list: [],
      poi_id: '',
      lat: null,
      lng: null,
      page_no: 1,
      page_size: 10,
      page_account: null,
      //  选择poi 选择器属性
      selectDestProp: {
        // checkStrictly: true,
        emitPath: false,
        label: 'loc_name', // 指定选项标签为选项对象的某个属性值
        value: 'loc_id', // 指定选项的值为选项对象的某个属性值
        children: 'children', // 指定选项的子选项为选项对象的某个属性值
      },
      //   添加poi选择器属性
      defaultProp: {
        multiple: false,
        checkStrictly: true,
        // emitPath: false,
        label: 'loc_name', // 指定选项标签为选项对象的某个属性值
        value: 'loc_id', // 指定选项的值为选项对象的某个属性值
        children: 'children', // 指定选项的子选项为选项对象的某个属性值
      },
      // 表单
      formLabelAlign: {
        poi_name: '',
        dest: '', // 选择的目的地
        location: {
          lat: '',
          lng: '',
        },
      },
      labelPosition: 'top',
    }
  },
  props: {
    proplat: {
      type: Number,
      default: 109.5142936706543,
    },
    proplng: {
      type: Number,
      default: 18.243943345260536,
    },
  },
  created() {
    this.loadDest()
    // this.getPoiHubList();
  },
  methods: {
    // 关闭窗口
    closeSubmitPOI() {
      this.$emit('closeSubmitPOI')
    },
    // 选择poi时
    handleSelectionChange(val) {
      // console.log(val)
      // 更新当前poi_id
      if (val) {
        this.poi_id = val.poi_id
        // 判断是否有经纬度
        if (val.lat == null) {
          this.$message({
            message: '未添加经纬度',
            type: 'error',
          })
        } else {
          // 用于显示
          this.$refs.pointOnMap.lat = parseFloat(val.lat)
          this.$refs.pointOnMap.lng = parseFloat(val.lng)
          this.$refs.pointOnMap.showPoiMarker(
            parseFloat(val.lat),
            parseFloat(val.lng)
          )
        }
      }
    },
    loadDest() {
      this.$http.get('/get_dest_level').then((res) => {
        this.option = res.data.data
      })
    },
    // 选择poi所在目的地
    selectPoiDest() {
      // 切片获取最后一个id/ 是否严格遵循
      if (this.destId != null) {
        // 通过借口获取 该id 拥有的poi 条目
        this.getPoiHubList(this.destId)
      } else {
        this.poi_list = []
      }
    },
    searchPoi() {
      this.getPoiHubList(this.destId)
    },
    // 获取 poi_hub列表【无用】
    getPoiHubList(dest_id) {
      this.$http
        .get(
          `/get_poi_hub_list?source_map=2&dest_id=${dest_id}&page_size=${this.page_size}&page_no=${this.page_no}&key_word=${this.keyWord}`
        )
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            this.poi_list = res.data.poi_list
            this.page_account = res.data.item_account
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    handleCurrentChange_system(page) {
      this.TripPlanList = []
      this.page_no = page
      this.getPoiHubList(this.destId)
    },
    // 地图选择关键词建议点后
    selectSuggestion(val) {
      this.formLabelAlign.location.lat = val.lat
      this.formLabelAlign.location.lng = val.lng
      this.formLabelAlign.poi_name = val.title
      this.formLabelAlign.dest = val.dest
      this.formLabelAlign.map_source = val.map_source
    },
    // 获取坐标
    getLatLng(lat, lng, map_source) {
      this.formLabelAlign.location.lat = lat
      this.formLabelAlign.location.lng = lng
      this.formLabelAlign.map_source = map_source
    },
    // 提交POI 给迹点
    submitPOI() {
      this.$http.post('/add_poi', this.formLabelAlign).then((res) => {
        if (res.data.errno == '0') {
          this.$emit('submitPoi', res.data.poi_id)
        } else {
          console.log(res)
          this.$message({
            message: res.data.errmsg,
            type: 'error',
          })
        }
      })
    },
    // 绑定 选择的poi 给迹点
    bandPoiToTraverPoint() {
      console.log(this.poi_id)
      this.$emit('submitPoi', this.poi_id)
    },
  },
}
</script>

<style>
.little-card-poi {
  display: flex;
  padding: 15px;
  flex-wrap: wrap;
  /* background-color: wheat; */
  flex-direction: column;
  border: 1px solid lightgray;
}
.add-poi-tab-pane {
  padding: 20px;
  border: 1px solid lightgrey;
}
</style>